export default __webpack_public_path__ + "static/media/hero-img1.12a6ce0c.png";